import ChatNotificationPermissionBanner from "Messenger/components/ChatNotificationPermissionBanner";
import useChatNotificationPermission from "Messenger/hooks/useChatNotificationPermission";
import useSendbirdPushRegistration from "Messenger/hooks/useSendbirdPushRegistration";
import useSendbirdDesktopNotifications from "Messenger/hooks/useSendbirdInactiveTabNotifications";

/**
 * Chat push token + desktop notifications. Must render under SendbirdProvider.
 * Used for account-owner/staff (via calls provider) and vendors (without Calls).
 */
const SendbirdNotificationRuntime = ({ children }) => {
  const { permission, requestPermission } = useChatNotificationPermission();
  useSendbirdPushRegistration(permission);
  useSendbirdDesktopNotifications();
  return (
    <>
      <ChatNotificationPermissionBanner
        permission={permission}
        onRequest={requestPermission}
      />
      {children}
    </>
  );
};

export default SendbirdNotificationRuntime;
